/** relationship type options */
export const RELATIONSHIP_STATUS_OPTIONS = [
  { key: "Ally", title: "Ally" },
  { key: "Coach", title: "Coach" },
  { key: "Unknown", title: "Unknown" },
];


// to relationship selected keys
export function toRelationshipSelectedKeys(status) {
  if (!status) return undefined;
  return new Set([status]);
}
